import React from 'react';
import { Header } from '../auth/components/Header';

const Settings: React.FC = () => {
    return (
        <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
            {/* Header */}
            <Header hideSearch={true} hideBusinessSelector={true} />

            <div className="flex-1 overflow-auto p-8">
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>

                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-2xl">⚙️</span>
                        </div>
                        <h2 className="text-lg font-medium text-gray-900 mb-2">Settings Coming Soon</h2>
                        <p className="text-gray-500 max-w-md mx-auto">
                            Global configurations, user management, and system preferences will be available here.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
